import { apiClient } from '@/api/client'
import type { ApiSuccessResponse, PaginationMeta } from '@/types/api'

export interface AdminUser {
  id: number
  name: string
  email: string
  phone: string | null
  userType: string
  status: string
  emailVerifiedAt: string | null
  organizationId: number | null
  organizationName: string | null
  createdAt: string | null
}

export interface AdminUsersParams {
  user_type?: string
  status?: string
  q?: string
  per_page?: number
  page?: number
}

export const adminUsersApi = {
  // Backend returns the paginator fields directly as `meta` (not meta.pagination).
  list: async (params: AdminUsersParams = {}): Promise<{ users: AdminUser[]; pagination: PaginationMeta }> => {
    const { data } = await apiClient.get<ApiSuccessResponse<AdminUser[]> & { meta: PaginationMeta }>('/admin/users', { params })
    return { users: data.data, pagination: data.meta }
  },
}
